export default __webpack_public_path__ + "static/media/ques.e1895932.gif";